<template>
  <div :class="clsx('api-integration-wrapper', { 'animations-disabled': !animationEnabled })" id="integrations">
    <IntersectionObserver
      class="api-integration-intersector"
      :animation-enabled="animationEnabled"
      :once="true"
      once-class="api-integration-intersector--visible"
      :threshold="isDesktop ? 0.4 : 0.3"
    >
      <BackgroundGridBlue class="grid">
        <div class="ukasko-features-wrapper">
          <div class="api-integration-ukasko-features">
            <UkaskoLogo class="api-integration-ukasko-features__logo" />
            <ul class="api-integration-ukasko-features__list">
              <li class="api-integration-ukasko-features__item api-integration-ukasko-features__item--fast-connection">
                <span class="api-integration-ukasko-features__item-text">Швидке підключення</span>
              </li>
              <li class="api-integration-ukasko-features__item api-integration-ukasko-features__item--flexible-documentation">
                <span class="api-integration-ukasko-features__item-text">Гнучка документація для розробників</span>
              </li>
              <li class="api-integration-ukasko-features__item api-integration-ukasko-features__item--team-support">
                <span class="api-integration-ukasko-features__item-text">Підтримка від технічної команди</span>
              </li>
            </ul>
            <div class="api-integration-ukasko-features__controls">
              <OrangeFancyButtonWithArrowAnimation hash="#subscribe" class="api-integration-ukasko-features__subscribe-button">
                Записатись на презентацію
              </OrangeFancyButtonWithArrowAnimation>
              <TransparencyFancyButton :route="{ name: 'registration' }" class="api-integration-ukasko-features__register-button">
                Зареєструватися самостійно
                <span class="api-integration-ukasko-features__register-icon"><ContactIcon /></span>
              </TransparencyFancyButton>
            </div>
          </div>
        </div>
        <div class="api-integration-crm-description">
          <h3 class="api-integration-crm-description__title">
            <span class="api-integration-crm-description__title-part--0">UConnect CRM</span>
            <span class="api-integration-crm-description__title-part--1"> легко інтегрується з б</span>
            <span class="api-integration-crm-description__title-part--2">удь-яким бізнесом че</span>
            <span class="api-integration-crm-description__title-part--3">рез API а</span>
            <span class="api-integration-crm-description__title-part--4">бо брендований лендінг.</span>
          </h3>
        </div>
      </BackgroundGridBlue>
      <div class="api-integration-bottom-gradient"></div>
    </IntersectionObserver>
  </div>
</template>

<script>
import clsx from 'clsx';
import { mapGetters } from 'vuex';
import { OrangeFancyButtonWithArrowAnimation, TransparencyFancyButton } from '@/shared/ui/form';
import { ContactIcon, UkaskoLogo } from '@/shared/ui/icons';
import { IntersectionObserver } from '@/shared/ui/intersection-observer';
import { BackgroundGridBlue } from '@/shared/ui/promo';

export default {
  props: {
    animationEnabled: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    BackgroundGridBlue, UkaskoLogo, OrangeFancyButtonWithArrowAnimation, ContactIcon, TransparencyFancyButton,
    IntersectionObserver
  },
  computed: {
    ...mapGetters('layoutModule', ['isDesktop']),
  },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
.api-integration-intersector {
  position: relative;
  opacity: 1;
}

.grid {
  display: flex;
  justify-content: space-between;
  padding: 0 16px 75px 24px;

  @media (max-width: 1050px) {
    padding: 0 16px 75px 32px;
  }

  @media (max-width: 800px) {
    flex-direction: column;
    padding: 0 16px 75px 16px;
  }
}

.ukasko-features-wrapper {
  width: 40%;

  @media (max-width: 800px) {
    margin-bottom: 64px;
  }
}

.api-integration-ukasko-features {
  width: 350px;
  margin: 0 80px 0 auto;

  @media (max-width: 800px) {
    margin: 0 24px;
  }

  &__list {
    font-family: 'Inter', sans-serif;
    font-size: 18px;
    font-weight: 350;
    color: #09090B;
  }

  &__item {
    position: relative;
    padding: 0 0 55px 16px;

    &::before {
      content: '';
      position: absolute;
      top: 4px;
      left: -11px;
      background: linear-gradient(to bottom, #CADDFC, #6171E4);
      background-size: 100% 400%;
      background-position: 0% 0%;
      border: 3px solid #CADDFC;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      z-index: 1;
    }

    &::after {
      content: '';
      position: absolute;
      top: 4px;
      left: -2px;
      height: 100%;
      width: 3px;
      background-color: #CADDFC;
    }

    &:last-child {
      border-left: none;

      &::after {
        display: none;
      }
    }

    &-text {
      width: calc(100% - 20px);
      display: inline-block;
    }

    &--fast-connection {
      &::before {
        animation: ukasko-features-item-circle-animation 0.05s linear forwards;
        animation-play-state: paused;
      }
      &::after {
        animation: ukasko-features-item-line-animation 1s linear forwards;
        animation-play-state: paused;
      }
    }

    &--flexible-documentation {
      &::before {
        animation: ukasko-features-item-circle-animation 0.05s linear forwards;
        animation-delay: 1s;
        animation-play-state: paused;
      }
      &::after {
        animation: ukasko-features-item-line-animation 1s linear forwards;
        animation-delay: 1s;
        animation-play-state: paused;
      }
    }

    &--team-support {
      &::before {
        animation: ukasko-features-item-circle-animation 0.05s forwards;
        animation-delay: 2s;
        animation-play-state: paused;
      }
    }
  }

  &__controls {
    display: flex;
    flex-direction: column;

    @media (max-width: 1050px) {
      margin: 0 24px 0 -16px;
    }

    @media (max-width: 800px) {
      margin: 0 40px 0 -16px;
    }
  }

  &__subscribe-button {
    margin-bottom: 25px;
  }

  &__logo {
    margin-bottom: 70px;

    @media (max-width: 800px) {
      margin-bottom: 40px;
    }
  }

  &__register-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    background-color: #FFFFFF;
    border-radius: 50%;
    margin-left: 10px;
  }
}

.api-integration-crm-description {
  display: flex;
  align-items: center;
  width: 60%;
  padding-left: 30px;

  @media (max-width: 1050px) {
    width: 55%;
  }

  @media (max-width: 800px) {
    width: 100%;
    padding-left: 8px;
  }

  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 52px;
    font-weight: 500;
    color: #CADDFC;
    width: 680px;

    @media (max-width: 1050px) {
      font-size: 46px;
    }
  }
}

.api-integration-crm-description__title-part--0 {
  animation: title-animation 0.5s linear forwards;
  animation-play-state: paused;
}

.api-integration-crm-description__title-part--1 {
  animation: title-animation 0.5s linear forwards;
  animation-delay: 0.5s;
  animation-play-state: paused;
}

.api-integration-crm-description__title-part--2 {
  animation: title-animation 0.5s linear forwards;
  animation-delay: 1s;
  animation-play-state: paused;
}

.api-integration-crm-description__title-part--3 {
  animation: title-animation 0.5s linear forwards;
  animation-delay: 1.5s;
  animation-play-state: paused;
}

.api-integration-crm-description__title-part--4 {
  animation: title-animation 0.5s linear forwards;
  animation-delay: 2s;
  animation-play-state: paused;
}

.api-integration-bottom-gradient {
  position: absolute;
  bottom: 0;
  height: 50px;
  width: 100%;
  background: linear-gradient(180deg, rgba(252, 253, 255, 0) 0%, #FCFDFF 100%);
  z-index: 1;
}

.api-integration-intersector {
  &--visible {
    .api-integration-crm-description__title-part--0,
    .api-integration-crm-description__title-part--1,
    .api-integration-crm-description__title-part--2,
    .api-integration-crm-description__title-part--3,
    .api-integration-crm-description__title-part--4 {
      animation-play-state: running;
    }

    .api-integration-ukasko-features__item--fast-connection::before,
    .api-integration-ukasko-features__item--fast-connection::after,
    .api-integration-ukasko-features__item--flexible-documentation::before,
    .api-integration-ukasko-features__item--flexible-documentation::after,
    .api-integration-ukasko-features__item--team-support::before {
      animation-play-state: running;
    }
  }
}

.animations-disabled,
.animations-disabled * {
  animation: none !important;
  animation-duration: 0s !important;
  animation-delay: 0s !important;
  transition: none !important;
}

.animations-disabled {
  .api-integration-ukasko-features__item {
    &--fast-connection, &--flexible-documentation, &--team-support {
      &::before {
        border-color: #6171E4 !important;
      }

      &::after {
        background: linear-gradient(to bottom, #6171E4 100%, #CADDFC 100%) !important;
      }
    }
  }

  .api-integration-crm-description__title-part--0,
  .api-integration-crm-description__title-part--1,
  .api-integration-crm-description__title-part--2,
  .api-integration-crm-description__title-part--3,
  .api-integration-crm-description__title-part--4 {
    color: #313437;
  }
}

@keyframes title-animation {
  from {
    color: #CADDFC;
  }
  to {
    color: #313437;
  }
}

@keyframes ukasko-features-item-line-animation {
  0% {
    background: linear-gradient(to bottom, #6171E4 0%, #CADDFC 0%);
  }
  10% {
    background: linear-gradient(to bottom, #6171E4 10%, #CADDFC 10%);
  }
  20% {
    background: linear-gradient(to bottom, #6171E4 20%, #CADDFC 20%);
  }
  30% {
    background: linear-gradient(to bottom, #6171E4 30%, #CADDFC 30%);
  }
  40% {
    background: linear-gradient(to bottom, #6171E4 40%, #CADDFC 40%);
  }
  50% {
    background: linear-gradient(to bottom, #6171E4 50%, #CADDFC 50%);
  }
  60% {
    background: linear-gradient(to bottom, #6171E4 60%, #CADDFC 60%);
  }
  70% {
    background: linear-gradient(to bottom, #6171E4 70%, #CADDFC 70%);
  }
  80% {
    background: linear-gradient(to bottom, #6171E4 80%, #CADDFC 80%);
  }
  90% {
    background: linear-gradient(to bottom, #6171E4 90%, #CADDFC 90%);
  }
  100% {
    background: linear-gradient(to bottom, #6171E4 100%, #CADDFC 100%);
  }
}

@keyframes ukasko-features-item-circle-animation {
  from {
    border-color: #CADDFC;
  }
  to {
    border-color: #6171E4;
  }
}
</style>
